import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';

import cx from 'classnames';

interface VoteCounterProps {
	voteCount: number;
	className?: string;
	fontStyle?: React.CSSProperties;
}

const useStyles = makeStyles((theme) => ({
	container: {
		display: 'flex',
		alignItems: 'center',
        [theme.breakpoints.down('xs')]: {
			flexDirection: 'column'
		}
	},
	countBox: {
		backgroundColor: 'var(--color-white)',
		borderRadius: 16,
		height: 64,
		paddingLeft: 39,
		paddingRight: 39,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'end',
		flex: 1,
        [theme.breakpoints.down('xs')]: {
    		height: 46,
    		padding: '7px 11px',
    		width: '100%',
    		boxSizing: 'border-box',
    		borderradius: 8
        },
	},
	countText: {
		fontSize: 48,
		fontWeight: 'bold',
		lineHeight: '1',
        [theme.breakpoints.down('xs')]: {
			fontSize: 24,
        },
	},
	label: {
		fontSize: 36,
		marginLeft: 16,
        [theme.breakpoints.down('xs')]: {
			fontSize: 16,
			marginLeft: 0,
			marginTop: 8
		}
	},
}));

const formatNumber = (num: number): string =>
	num.toLocaleString('en-US');

const VoteCounter: React.FC<VoteCounterProps> = ({ voteCount, className, fontStyle }) => {
	const classes = useStyles();

	return (
		<Box className={cx(classes.container, className)}>
			<Box className={classes.countBox}>
				<Typography className={classes.countText} style={{ color: 'var(--color-tertiary)'}}>
					{formatNumber(voteCount)}
				</Typography>
			</Box>
			<Typography className={classes.label} style={fontStyle}>票</Typography>
		</Box>
	);
};

export default VoteCounter;
